// extracted by mini-css-extract-plugin
module.exports = {"iconRight":"Button_iconRight__2KTGo"};